import { useContext } from "react";
import { notification } from "antd";
import { deleteRequest, getDataRequest, getRequest, handleResponse, patchFormRequests, patchRequest, postFormRequest } from "../../context/requestTypes";
import { AxiosContext } from "../../context/AxiosContext";
import { useMutation, useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import authAtom from "../../atoms/auth/auth.atom";



export function useGetTransactions(params, key) { // /api/v1/Transaction/GetTransactions
  const url = "/Transaction/GetTransactions"; 
  const axios = useContext(AxiosContext);
  return useQuery(["key:get_all_Transaction", ...(key||[])?.map(d => params?.[d])], () => getRequest(axios, url, params), {
    onSuccess: (response) => handleResponse(response),

    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useGetPostTransaction(successAction) { // /api/v1/Transaction/CreateTransaction
  const url = "/Transaction/GetTransactions"; 
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => getDataRequest(url, payload, user?.token), {    
    onSuccess: (response) => handleResponse(response, () => successAction?.()),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useGetTransaction(successAction) {
  const url = "/Transaction/GetTransaction/";
  const axios = useContext(AxiosContext);
  return useMutation((id) => getRequest(axios, url+id), {
    onSuccess: (response) => handleResponse(response, () => successAction?.()),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePostTransaction(successAction) { // /api/v1/Transaction/CreateTransaction
    const url = "/Transaction/CreateTransaction"; 
    const { user } = useRecoilValue(authAtom)
    return useMutation((payload) => postFormRequest(url, payload, user?.token), {
      onSuccess: (response) => {
        handleResponse(response, () => {
          successAction?.()
          notification.success({
            message: "Success!",
            description: response?.message || "action successful",
          })
        })
      },
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }

  export function useDeleteTransaction(successAction) {
    const url = `/Transaction/DeleteTransaction/`; 
    const axios = useContext(AxiosContext);
    return useMutation((id) => deleteRequest(axios, url+id), {
      onSuccess: (response) => {
        handleResponse(response, () => {
          successAction?.()
          notification.success({
            message: "Success!",
            description: response?.message || "action successful",
          })
        })
      },
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }



export function usePatchTransaction(successAction) {
  const url = `/Transaction/EditTransaction/`; 
  const axios = useContext(AxiosContext);
  return useMutation((payload) => patchRequest(axios, url+payload?.id, payload), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePatchBlog(successAction) {
  const url = "/Blog/EditBlog/"; 
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => patchFormRequests(url+payload?.id, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}